// Droits possédés par le joueur, en mémoire (source : /me). Rafraîchi au démarrage
// et après chaque achat. Sert à afficher l'état « possédé » et (plus tard) à gater.
import { getMe } from "./api";

let owned = new Set<string>();
let admin = false;
let coins = 0;
let userId = 0;
let referrals = 0;
let boosters: Record<string, number> = {};

export function setEntitlements(items: string[]): void {
  owned = new Set(items);
}

/** Le joueur possède-t-il ce droit ? */
export function ownsItem(id: string): boolean {
  return owned.has(id);
}

/** Le joueur est-il admin (outils de test) ? */
export function isAdmin(): boolean {
  return admin;
}

/** Solde de pièces en mémoire. */
export function getCoins(): number {
  return coins;
}
export function setCoins(n: number): void {
  coins = n;
}

/** Id Telegram du joueur (pour le lien de parrainage) et nb de filleuls. */
export function getUserId(): number {
  return userId;
}
export function getReferrals(): number {
  return referrals;
}

/** Inventaire de boosters { slow: 2, … } (quantités possédées). */
export function getBoosterQty(id: string): number {
  return boosters[id] ?? 0;
}
export function setBoosters(b: Record<string, number>): void {
  boosters = b;
}
export function hasAnyBooster(): boolean {
  return Object.values(boosters).some((n) => n > 0);
}

/** Recharge droits + pièces + statut admin depuis l'API (best-effort). */
export async function refreshEntitlements(initData: string): Promise<void> {
  if (!initData) return;
  const res = await getMe(initData);
  if (res.ok) {
    setEntitlements(res.data.entitlements);
    admin = !!res.data.admin;
    coins = res.data.coins ?? 0;
    userId = res.data.user?.id ?? 0;
    referrals = res.data.referrals ?? 0;
    boosters = res.data.boosters ?? {};
  }
}
